export const DEFAULT_ROLE_NAME = "modify";

// Pattern B: `label` is a selector resolved at the consumer's t scope so the
// role label is translated against the user_management namespace.
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type LabelSelector = ($: any) => any;

export const ROLES: { label: LabelSelector; value: string }[] = [
  { label: ($) => $.user_management["Read Only"], value: "read_only" },
  { label: ($) => $.user_management["Modify"], value: "modify" },
  { label: ($) => $.user_management["Org Admin"], value: "org_admin" },
];
